<template>
  <div>
    <v-carousel
      hide-delimiter-background
      hide-delimiters
      cycle
      :height="$vuetify.breakpoint.xsOnly ? 200 : $vuetify.breakpoint.smOnly ? 320 : 600"
      :show-arrows="false"
      interval="4000"
    >
      <v-carousel-item v-for="(banner, index) in banners" :key="index">
        <v-img :src="banner.src" :alt="banner.alt" class="banner-image" cover />
      </v-carousel-item>
    </v-carousel>

    <v-container class="about-section">
      <v-row align="center" justify="space-between">
        <v-col cols="12" md="6" class="pr-md-8">
          <h1 class="about-h1">มาทำความรู้จักกับ</h1>
          <br>
          <h3 class="about-h3">กิจการร่วมค้า กรกรฏ ก๊อด แอนด์ คอนซัลแต้นท์</h3>
          <br />
          <p class="about-text">
            เราเป็นบริษัทนำเสนองานออกแบบและควบคุมงานก่อสร้างโดยมุ่งเน้นคุณภาพทั้งด้านความงาม
            และความมั่นคงของโครงสร้าง
            เราดูแลทุกขั้นตอนของโครงการอย่างใกล้ชิดตั้งแต่แนวคิดเบื้องต้นการออกแบบรายละเอียด
            การจัดทำแบบก่อสร้าง เราจึงยึดมั่นในความโปร่งใส การสื่อสารที่ชัดเจน
            และการทำงานร่วมกับลูกค้าอย่างมืออาชีพ
            เพื่อส่งมอบโครงการที่ตอบโจทย์จริง และยั่งยืนในระยะยาว
          </p>
        </v-col>

        <v-col cols="12" md="6" class="text-center">
          <v-img :src="require('@/assets/home/interesting.png')" alt="Interesting" class="about-image" contain />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "AboutUSBannerDetail",
  data() {
    return {
      banners: [
        { src: require("@/assets/home/banner3.png"), alt: "Banner 3" },
      ],
    };
  },
};
</script>

<style scoped>
.banner-image {
  width: 100%;
  height: 100%;
}

.about-section {
  max-width: 1440px;
  margin: 0 auto;
  padding: 80px 40px 60px;
  box-sizing: border-box;
}

@media (min-width: 1440px) and (max-width: 1919px) {
  .about-section {
    max-width: 1200px;
  }
}

.about-h1 {
  font-size: 40px;
  font-weight: 600;
}

.about-h3 {
  font-size: 28px;
}

.about-text {
  font-size: 16px;
  line-height: 1.8;
}

@media (max-width: 768px) {
  .about-section {
    padding: 36px 16px 40px;
  }

  .about-h1 {
    font-size: 24px;
  }

  .about-h3 {
    font-size: 18px;
  }

  .about-text {
    font-size: 14px;
  }
}
</style>
